import { useState } from 'react'
import PasswordInput from '../components/PasswordInput'

function Login({ onLogin, loginError, loggingIn, onForgotPassword, resetMessage, resetting, onGoToSignup }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  return (
    <main className="screen onboarding-screen">
      <section className="onboarding-card">
        <div className="account-header">
          <img src="/logo192.png" alt="" className="account-logo" />
          <h1>Login</h1>
        </div>

        <div className="question-block">
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="tu@email.com"
              autoFocus
            />
          </label>
          <label>
            Contraseña
            <PasswordInput value={password} onChange={(event) => setPassword(event.target.value)} />
          </label>
        </div>

        {loginError && <p className="error-text">{loginError}</p>}
        {resetMessage && <p className="success-text">{resetMessage}</p>}

        <div className="actions">
          <button
            type="button"
            className="primary full-width"
            disabled={loggingIn}
            onClick={() => onLogin(email, password)}
          >
            {loggingIn ? 'Ingresando...' : 'Iniciar sesion'}
          </button>
        </div>

        <div className="login-links">
          <button type="button" className="forgot-password" disabled={resetting} onClick={() => onForgotPassword(email)}>
            {resetting ? 'Enviando...' : '¿Olvidaste tu contraseña?'}
          </button>
          <button type="button" className="forgot-password" onClick={onGoToSignup}>
            Crear cuenta
          </button>
        </div>
      </section>
    </main>
  )
}

export default Login
